module.exports = __webpack_public_path__ + "static/media/screen6.480b6b65.jpeg";